@if (sizeOptions().length) {
  <div class="page-size">
    <span
      class="label"
      aria-hidden="true">
      Items per page
    </span>
    <app-select
      class="size-select"
      placeholder="Items per page"
      [options]="sizeOptions()"
      [value]="pageSize()"
      (valueChange)="changePageSize($event)" />
  </div>
}

<span
  class="range"
  aria-live="polite">
  {{ range() }}
</span>

<div class="buttons">
  @if (showFirstLast()) {
    <app-button
      class="icon"
      variant="stroked"
      color="neutral"
      ariaLabel="First page"
      [disabled]="!hasPrevious()"
      (click)="goTo(0)">
      <mat-icon>first_page</mat-icon>
    </app-button>
  }
  <app-button
    class="icon"
    variant="stroked"
    color="neutral"
    ariaLabel="Previous page"
    [disabled]="!hasPrevious()"
    (click)="goTo(pageIndex() - 1)">
    <mat-icon>chevron_left</mat-icon>
  </app-button>
  <app-button
    class="icon"
    variant="stroked"
    color="neutral"
    ariaLabel="Next page"
    [disabled]="!hasNext()"
    (click)="goTo(pageIndex() + 1)">
    <mat-icon>chevron_right</mat-icon>
  </app-button>
  @if (showFirstLast()) {
    <app-button
      class="icon"
      variant="stroked"
      color="neutral"
      ariaLabel="Last page"
      [disabled]="!hasNext()"
      (click)="goTo(lastPageIndex())">
      <mat-icon>last_page</mat-icon>
    </app-button>
  }
</div>
